// ROI model grounded in Fresh Earth / OED field data (UltraTech proposal & OED deck):
// - Dosage ~1–2 L per tonne; on-site bio-culture ₹115–125/L (volume tiers)
// - SWM economics: ~₹150/t cost, up to 70% weight reduction, residue sold ~₹2/kg
// - Bio-CNG: +20–30% biogas; odour control 100% within a week

export const APPLICATIONS = {
  "Legacy Landfill / SWM": { dosage: 1.5, reduction: 0.7, speed: "4×", biogas: 0 },
  "RDF (Cement Plant)": { dosage: 1.0, reduction: 0.55, speed: "3×", biogas: 0 },
  "Bio-mining": { dosage: 1.5, reduction: 0.6, speed: "4×", biogas: 0 },
  "Bio-CNG": { dosage: 1.5, reduction: 0.4, speed: "—", biogas: 0.25 },
  "STP / Wastewater": { dosage: 0.02, reduction: 0.0, speed: "—", biogas: 0 },
};

const SELL_PRICE_PER_KG = 2; // ₹ per kg of recovered material

export function pricePerLitre(monthlyLitres) {
  if (monthlyLitres <= 20000) return 125;
  if (monthlyLitres <= 40000) return 120;
  if (monthlyLitres <= 80000) return 118;
  if (monthlyLitres <= 100000) return 116;
  return 115;
}

export function computeRoi({ application, tonnesPerDay, monthlySpend }) {
  const cfg = APPLICATIONS[application];
  const monthlyLitres = tonnesPerDay * cfg.dosage * 30;
  const priceL = pricePerLitre(monthlyLitres);

  const costPerTonne = cfg.dosage * priceL; // ₹ / tonne
  const recoveredKg = 1000 * cfg.reduction; // sellable residue per tonne
  const revenuePerTonne = recoveredKg * SELL_PRICE_PER_KG; // ₹ / tonne
  const netPerTonne = Math.max(0, revenuePerTonne - costPerTonne);

  const annualThroughput = tonnesPerDay * 365;
  const annualNetValue = netPerTonne * annualThroughput + (monthlySpend || 0) * 12;

  return {
    application,
    tonnesPerDay,
    monthlySpend: monthlySpend || 0,
    dosage: cfg.dosage,
    priceL,
    odour: 100,
    reduction: Math.round(cfg.reduction * 100),
    speed: cfg.speed,
    biogas: cfg.biogas ? Math.round(cfg.biogas * 100) : 0,
    costPerTonne: Math.round(costPerTonne),
    revenuePerTonne: Math.round(revenuePerTonne),
    netPerTonne: Math.round(netPerTonne),
    annualNetValue: Math.round(annualNetValue),
  };
}

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(n || 0));
